import type { ReactElement } from 'react'
import { Navigate } from 'react-router-dom'

import { FeatureFlagKeys } from '@hapana/shared/constants/feature-flag.constants'
import { useFeatureFlag } from '_hooks/useFeatureFlag'

import { ROUTES } from '../../../app.constants'

interface BrandScheduleSettingsRouteGuardProps {
  children: ReactElement
}

const BrandScheduleSettingsRouteGuard = ({ children }: BrandScheduleSettingsRouteGuardProps) => {
  const { value: isEnabled, isLoading } = useFeatureFlag(
    FeatureFlagKeys.BrandControlsSessionGroupsEnabled,
    { defaultValue: false }
  )
  if (isLoading) {
    return null
  }
  if (!isEnabled) {
    return <Navigate to={`/c/${ROUTES.controlCenter.path}`} replace />
  }
  return children
}

export default BrandScheduleSettingsRouteGuard
